<template>
  <div class="heatTreatmentInquireResult container">
    <div class="px-0">
      <b-col cols="12" class="px-0">
        <div class="my-3">
          <b-table
            :items="heatTreatmentInquireResultItem"
            :fields="heatTreatmentInquireResultFields"
            :no-border-collapse="noCollapse"
            class="ht-inquery-result-table-detail"
          >
            <template #thead-top="">
              <b-tr>
                <b-th
                  colspan="7"
                  style="
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                  "
                >
                  <span>查詢結果</span>
                </b-th>
              </b-tr>
            </template>
          </b-table>
        </div>
        <div
          style="
            overflow-y: auto;
            width: 100%;
            min-width: 900px;
            text-align: right;
          "
        >
          <exportCsv />
        </div>
        <div
          v-if="htWorkValueItem.length > 0"
          class="my-3"
          style="overflow-y: auto; height: 550px; width: 100%; min-width: 900px"
        >
          <table class="ht-work-value-table">
            <thead class="sticky-thead">
              <th
                v-for="(item, index) in htWorkValueFields"
                :key="index"
                :style="{
                  'writing-mode':
                    item.key == 'time' ? 'horizontal-tb' : 'vertical-rl',
                }"
              >
                {{ item.label }}
              </th>
            </thead>
            <template v-for="item in htWorkValueItem">
              <tr>
                <td rowspan="2" style="background-color: #ffffff">
                  {{ item.time }}
                </td>
                <td style="min-width: 70px">設定值</td>
                <td
                  v-for="(set_item, set_key) in item.value.set"
                  :key="set_key"
                >
                  {{ set_item }}
                </td>
              </tr>
              <tr>
                <td style="min-width: 70px">實際值</td>
                <td
                  v-for="(act_item, act_key) in item.value.act"
                  :key="act_key"
                  :style="{
                    'background-color':
                      act_key == 'quench_furn_temp1' ||
                      act_key == 'quench_furn_temp2' ||
                      act_key == 'tempering_furn_temp1' ||
                      act_key == 'tempering_furn_temp2' ||
                      act_key == 'carb_tank_temp'
                        ? '#fff'
                        : item.value.set[act_key] > 100
                        ? item.value.set[act_key] + 30 < act_item ||
                          item.value.set[act_key] - 30 > act_item
                          ? '#c10000'
                          : item.value.set[act_key] + 15 < act_item ||
                            item.value.set[act_key] - 15 > act_item
                          ? '#ffc100'
                          : '#fff'
                        : item.value.set[act_key] < 1
                        ? item.value.set[act_key] + 0.1 < act_item ||
                          item.value.set[act_key] - 0.1 > act_item
                          ? '#c10000'
                          : item.value.set[act_key] + 0.05 < act_item ||
                            item.value.set[act_key] - 0.05 > act_item
                          ? '#ffc100'
                          : '#fff'
                        : item.value.set[act_key] + 20 < act_item ||
                          item.value.set[act_key] - 20 > act_item
                        ? '#c10000'
                        : item.value.set[act_key] + 10 < act_item ||
                          item.value.set[act_key] - 10 > act_item
                        ? '#ffc100'
                        : '#fff',
                    color:
                      act_key == 'quench_furn_temp1' ||
                      act_key == 'quench_furn_temp2' ||
                      act_key == 'tempering_furn_temp1' ||
                      act_key == 'tempering_furn_temp2' ||
                      act_key == 'carb_tank_temp'
                        ? '#4b8c80'
                        : item.value.set[act_key] > 100
                        ? item.value.set[act_key] + 30 < act_item ||
                          item.value.set[act_key] - 30 > act_item
                          ? '#fff'
                          : item.value.set[act_key] + 15 < act_item ||
                            item.value.set[act_key] - 15 > act_item
                          ? '#646569'
                          : '#4b8c80'
                        : item.value.set[act_key] < 1
                        ? item.value.set[act_key] + 0.1 < act_item ||
                          item.value.set[act_key] - 0.1 > act_item
                          ? '#fff'
                          : item.value.set[act_key] + 0.05 < act_item ||
                            item.value.set[act_key] - 0.05 > act_item
                          ? '#646569'
                          : '#4b8c80'
                        : item.value.set[act_key] + 20 < act_item ||
                          item.value.set[act_key] - 20 > act_item
                        ? '#fff'
                        : item.value.set[act_key] + 10 < act_item ||
                          item.value.set[act_key] - 10 > act_item
                        ? '#646569'
                        : '#4b8c80',
                  }"
                >
                  {{ act_item }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exportCsv from "@/components/exportCsv.vue";
export default {
  name: "heatTreatmentInquireResult",
  data() {
    return {
      noCollapse: false,
    };
  },
  components: {
    exportCsv,
  },
  watch: {},
  computed: {
    ...mapGetters({
      heatTreatmentInquireResultFields:
        "heatTreatmentInquireResult/get_heatTreatmentInquireResultFields",
      heatTreatmentInquireResultItem:
        "heatTreatmentInquireResult/get_heatTreatmentInquireResultItem",
      htWorkValueFields: "heatTreatmentInquireResult/get_htWorkValueFields",
      htWorkValueItem: "heatTreatmentInquireResult/get_htWorkValueItem",
    }),
  },
  methods: {},
};
</script>

<style lang="scss">
.ht-inquery-result-table-detail {
  min-width: 770px;
}
.ht-inquery-result-table-detail th,
.ht-inquery-result-table-detail td {
  height: 2.5rem;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.ht-inquery-result-table-detail th:first-child,
.ht-inquery-result-table-detail td:first-child {
  border-left: 1px solid;
}
.ht-inquery-result-table-detail th:last-child,
.ht-inquery-result-table-detail td:last-child {
  border-right: 1px solid;
}
.ht-inquery-result-table-detail {
  margin-bottom: 0px;
}
.ht-inquery-result-table-detail thead th {
  font-size: 1rem;
  color: #000000;
  background-color: #cccccc;
}
.ht-inquery-result-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.ht-inquery-result-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
.ht-work-value-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
}

.ht-work-value-table td {
  vertical-align: middle !important;
  border: 1px solid #000;
}

.ht-work-value-table tr:nth-child(odd) {
  color: #4b8c80;
  background-color: #ffffff;
}
.ht-work-value-table tr:nth-child(even) {
  background-color: #f0f0f0;
}

.ht-work-value-table thead th {
  padding: 5px;
  font-size: 1rem;
  color: #ffffff;
  background-color: #4b8c80;
  border: 1px solid #000;
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle !important;
  min-width: 30px;
}
.sticky-thead {
  position: sticky;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/heatTreatmentInquireResult.vue